module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/icon_close-b757e2ae17cd7fd4614a3e12da0cf4cd.svg";